module.exports = __webpack_public_path__ + "img/whitelines.fa505a5.png";